import { createAsyncThunk } from "@reduxjs/toolkit";
import { showToast } from "../toast/reducer";
import {
  createBooking,
  getAdminBookings,
  getAdminBookingById,
  deleteAdminBooking,
  getAvailableFarms,
  updateAdminBooking as updateAdminBookingAPI,
  updatePaymentStatus,
} from "../../helpers/apis";

export const fetchAvailableFarms = createAsyncThunk(
  "bookings/fetchAvailableFarms",
  async (params, thunkAPI) => {
    try {
      const response = await getAvailableFarms(params);
      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch available farms";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updateBooking = createAsyncThunk(
  "bookings/updateBooking",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await updateAdminBookingAPI(id, data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: "Booking updated successfully" }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to update booking";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updateBookingPaymentStatus = createAsyncThunk(
  "bookings/updateBookingPaymentStatus",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await updatePaymentStatus(id, data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: response.msg || "Payment status updated successfully" }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to update payment status";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fetchBookings = createAsyncThunk(
  "bookings/fetchBookings",
  async (params, thunkAPI) => {
    try {
      console.log('Fetching bookings with params:', params);
      const response = await getAdminBookings(params);
      console.log('Bookings API response:', response);

      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch bookings";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const fetchBookingDetails = createAsyncThunk(
  "bookings/fetchBookingDetails",
  async (id, thunkAPI) => {
    try {
      const response = await getAdminBookingById(id);
      if (!response.error) {
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to fetch booking details";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const addNewBooking = createAsyncThunk(
  "bookings/addNewBooking",
  async (data, thunkAPI) => {
    try {
      const response = await createBooking(data);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: "Booking created successfully" }));
        return response;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to create booking";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const removeBooking = createAsyncThunk(
  "bookings/removeBooking",
  async (id, thunkAPI) => {
    try {
      const response = await deleteAdminBooking(id);
      if (!response.error) {
        thunkAPI.dispatch(showToast({ type: "success", msg: "Booking deleted successfully" }));
        return id;
      } else {
        thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
        return thunkAPI.rejectWithValue(response.msg);
      }
    } catch (error) {
      const errorMsg = error.message || "Failed to delete booking";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);